var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MainMenu'),_c('div',{staticStyle:{"overflow":"hidden","height":"100%"},attrs:{"id":"therapist-main"}},[_vm._v(" therapist ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }